// Loaded from layout/theme.liquid so that predictive-search.js and
// main-search.js, which both do `extends SearchForm`, always find this class —
// whichever header section is active.
//
// The guard exists because sections/header.liquid loads this file too. That
// section is currently disabled in favour of smi-header-1-7, but if it is ever
// switched back on the file would be included twice, and a second top-level
// `class SearchForm` declaration is a SyntaxError that takes down every script
// after it. Assigning to window keeps the class reachable as a bare identifier
// from the other files.
if (!window.SearchForm) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');

      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener(
          'input',
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this)
        );
      }
    }

    toggleResetButton() {
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }

    onChange() {
      this.toggleResetButton();
    }

    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }

    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  }

  window.SearchForm = SearchForm;
  customElements.define('search-form', SearchForm);
}
